import { render, staticRenderFns } from "./scenariomodal.component.html?vue&type=template&id=1903ab80&scoped=true&"
import script from "./scenariomodal.component.ts?vue&type=script&lang=ts&"
export * from "./scenariomodal.component.ts?vue&type=script&lang=ts&"
import style0 from "./scenariomodal.component.scss?vue&type=style&index=0&id=1903ab80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1903ab80",
  null
  
)

export default component.exports